<form [formGroup]="form" class="visualized-in-desktop">
    <mat-button-toggle-group [hideSingleSelectionIndicator]="true"
                             formControlName="objectIds"
                             [multiple]="multiple"
    >
        @for (pValue of possibleValues; track pValue) {
            <mat-button-toggle [value]="pValue.objectId">
                <ng-container [ngTemplateOutlet]="GETICON"
                              [ngTemplateOutletContext]="pValue">

                </ng-container>
                <ng-container [ngTemplateOutlet]="GETTRADUCTION"
                              [ngTemplateOutletContext]="pValue">

                </ng-container>
            </mat-button-toggle>
        }

    </mat-button-toggle-group>
</form>
<div class="visualized-in-Mobile">
    @if (mode == 'iconMode') {
        <button mat-button
                [disabled]="disableButton"
                [class]="shape"
                [color]="color"
                [matMenuTriggerFor]="menu">
            @if (!this.multiple && (currentpValue$|async); as pValue) {
                <ng-container [ngTemplateOutlet]="GETICON"
                              [ngTemplateOutletContext]="pValue">

                </ng-container>
            } @else {
                <mat-icon>add</mat-icon>
            }
        </button>
    } @else {
        <button mat-flat-button
                [disabled]="disableButton"
                [color]="color"
                [matMenuTriggerFor]="menu"
                [matBadge]="numberSelected$|async">
            @if (!this.multiple && (currentpValue$|async); as pValue) {
                <ng-container [ngTemplateOutlet]="GETTRADUCTION"
                              [ngTemplateOutletContext]="pValue">

                </ng-container>
            } @else if (title) {
                {{ title }}
            } @else {
                <mat-icon>add</mat-icon>
            }
        </button>
    }
    <mat-menu #menu="matMenu">
        @for (pValue of possibleValues; track pValue) {
            <a mat-menu-item (click)="setValue(pValue.objectId)" style="text-align: center"
               [ngClass]="{'background-color-primary-transparent':pValue|transformValueByPredicateFunction:isEqualsPredicate:(currentObjectId$|async):(currentObjectIds$|async)}"
            >
                <ng-container [ngTemplateOutlet]="GETICON"
                              [ngTemplateOutletContext]="pValue">

                </ng-container>
                <ng-container [ngTemplateOutlet]="GETTRADUCTION"
                              [ngTemplateOutletContext]="pValue">
                </ng-container>
            </a>
        }
    </mat-menu>

    <ng-template #GETICON let-icon="icon" let-svgIcon="svgIcon">
        @if (icon) {
            <mat-icon>{{ icon }}</mat-icon>
        } @else if (svgIcon) {
            <mat-icon [svgIcon]="svgIcon"></mat-icon>
        }
    </ng-template>
    <ng-template #GETTRADUCTION let-traduction="traduction" let-sensorDataTraduction="sensorDataTraduction"
                 let-notTraduction="notTraduction">
        @if (traduction) {
            {{ traduction|translate }}
        } @else if (sensorDataTraduction) {
            {{ sensorDataTraduction|sensorDataTraduction$|async }}
        } @else if (notTraduction) {
            {{ notTraduction }}
        }
    </ng-template>
</div>
